<template>
    <div>
        <b-modal :title="selectedGallery.title" class="modal-danger" v-model="galleryModal" @ok="galleryModal = false" ok-variant="danger" hide-footer size="xl" v-if="selectedGallery">
            <div class="ratio ratio-16x9">
                <iframe
                :src="this.selectedGallery.mediaUrl"
                :title="this.selectedGallery.name"
                allowfullscreen
                :width="this.selectedGallery.modalWidth"
                :height="this.selectedGallery.modalHeight"
                ></iframe>
            </div>
        </b-modal>
       
        <div class="row">
            <div class="col-lg-4 mb-4 mb-lg-0" v-for="item in galleries" :key="item.id">
                <div
                    class="bg-image hover-overlay ripple shadow-1-strong rounded"
                    data-ripple-color="light"
                >
                    <a href="#" @click="openModal(item)">
                    <img
                    :src=item.imageUrl
                    class="media-image"
                    />          
                    </a>
                </div>
            </div>

      </div>

    </div>    
    

</template>>

<script>
import axios from "axios";

export default {
    name: 'componentGallery',
    data: function() {
        return {
            galleryModal: false,
            selectedGallery: null,
            galleries: [
                /*
                {
                    id: 1,
                    title: "Concorra a uma viagem para a Alemanha",
                    image: "http://www.a6i.com.br/agulhasnegras/images/viagem5.webp",
                    src: "https://www.youtube.com/embed/NOpTbxNYw3c",
                    class: "w-100",
                    width: "100%",
                    height: "600px"
                },
                {
                    id: 2,
                    title: "My BMW App",
                    image: "http://www.a6i.com.br/agulhasnegras/images/mybmw.png",
                    src: "https://www.youtube.com/embed/jWIm2UoMSg4",
                    class: "w-100",
                    width: "100%",
                    height: "600px"
                },
                {
                    id: 3,
                    title: "Mega Sale Online BMW Agulhas Negras",
                    image: "http://www.a6i.com.br/agulhasnegras/images/megasale.png",
                    src: "https://www.youtube.com/embed/HskxCiSElEg",
                    class: "w-100",
                    width: "100%",
                    height: "600px"
                },
                */
            ]
        }
    },
    methods: {
        openModal(item) {
            this.selectedGallery = item;
            this.galleryModal=true;
        },
        async refreshData() {
            var s = this
            var currentUserURL = currentUserURL = "&uid=" + this.$store.state.currentUser.id + "&sid=" + this.$store.state.currentUser.sid;
            
            if(currentUserURL.indexOf("undefined") >= 0)
                currentUserURL = ''

            await axios.get(
                this.$store.state.ws_url + "/portal/media?companyId=" + this.$store.state.config.companyId + currentUserURL
            ).then(function(resp) {
                s.galleries = resp.data.obj;
            }).catch(function(error) {
                console.log(error)
                s.galleries = []
            })
        },
        
    },
    mounted: function(){
        this.refreshData();
    }
}

</script>

<style scoped>
.media-image {
    max-height: 180px;
}
</style>